/* Utils */
import { generateSelectEntityById, generateSelectEntitiesByIdsList } from '../utils/generators/selectorGenerators';

export const selectAllSchedules = (state) => state.schedules;

export const selectScheduleById = generateSelectEntityById(selectAllSchedules);

export const selectScheduleListByIdsList = generateSelectEntitiesByIdsList(
  selectAllSchedules,
);
